<script setup lang="ts">
import Accordion from "primevue/accordion";
import { useI18n } from "vue-i18n";

defineProps({
    active: {
        type: Number,
        default: 1,
    },
    billed: {
        type: Boolean,
        default: false,
    },
});

const { t } = useI18n();
</script>

<template>
    <h2 class="text-secondary">{{ t("profile-overview.instructions.heading") }}</h2>
    <Accordion :value="active" class="accordion-custom">
        <AccordionPanel :value="0">
            <AccordionHeader>
                <div class="flex items-center justify-start">
                    <i class="pi pi-shopping-cart"></i>
                    <span v-if="billed">{{ t("profile-overview.instructions.buy.billed.heading") }}</span>
                    <span v-else>{{ t("profile-overview.instructions.buy.shop.heading") }}</span>
                </div>
            </AccordionHeader>
            <AccordionContent>
                <p class="pt-2" v-if="billed" v-html="t('profile-overview.instructions.buy.billed.text')"></p>
                <p class="pt-2" v-else v-html="t('profile-overview.instructions.buy.shop.text')"></p>
            </AccordionContent>
        </AccordionPanel>
        <AccordionPanel :value="1">
            <AccordionHeader>
                <div class="flex items-center justify-start">
                    <i class="pi pi-list"></i>
                    <span>{{ t("profile-overview.instructions.view.heading") }}</span>
                </div>
            </AccordionHeader>
            <AccordionContent>
                <p class="pt-2" v-html="t('profile-overview.instructions.view.text')"></p>
            </AccordionContent>
        </AccordionPanel>
        <AccordionPanel :value="2">
            <AccordionHeader>
                <div class="flex items-center justify-start">
                    <i class="pi pi-megaphone"></i>
                    <span>{{ t("profile-overview.instructions.use.heading") }}</span>
                </div>
            </AccordionHeader>
            <AccordionContent>
                <p class="pt-2" v-html="t('profile-overview.instructions.use.text')"></p>
            </AccordionContent>
        </AccordionPanel>
        <AccordionPanel :value="3">
            <AccordionHeader>
                <div class="flex items-center justify-start">
                    <i class="pi pi-user-edit"></i>
                    <span>{{ t("profile-overview.instructions.manage.heading") }}</span>
                </div>
            </AccordionHeader>
            <AccordionContent>
                <p class="pt-2" v-html="t('profile-overview.instructions.manage.text')"></p>
            </AccordionContent>
        </AccordionPanel>
    </Accordion>
</template>

<style scoped>
.accordion-custom i span {
    vertical-align: middle;
}

.accordion-custom span {
    margin: 0 0.5rem;
}

.p-accordion p {
    line-height: 1.5;
    margin: 0;
}
</style>
